import { render } from "./ReceiptAlert.vue?vue&type=template&id=ccc4d0e0&scoped=true"
import script from "./ReceiptAlert.vue?vue&type=script&lang=js"
export * from "./ReceiptAlert.vue?vue&type=script&lang=js"

import "./ReceiptAlert.vue?vue&type=style&index=0&id=ccc4d0e0&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc4d0e0"]])

export default __exports__